export { default } from "./scrollbars.inner";
